module.exports = __webpack_public_path__ + "static/media/folder2-icon.ed7d794b.png";